<template>
	<div v-show="bodyIsShow">
		<input id="applyId" type="hidden" :value="applyId">
		<div class="bodywrap">
        	<section v-if="(periods.successBannerList.length>0) && (periods.successBannerCb==true)">
	     		<mt-swipe :auto="4000">
				  <mt-swipe-item v-for="(item,index) in periods.successBannerList">
				  	<a v-if="item.text" :href="item.text">
				  		<img style="width:100%" :class="['swiper-img',{'trackEvent':(periods.cityId == 170 && index==0)}]" data-track="carfestivalDetail-10-linkToAd-detail" :src="commmonWebConfig.picHost+'/'+periods.picUrl+item.imageName">
				  	</a>
				  	<img v-else style="width:100%" :class="['swiper-img',{'trackEvent':(periods.cityId == 170 && index==0)}]" data-track="carfestivalDetail-10-linkToAd-detail" :src="commmonWebConfig.picHost+'/'+periods.picUrl+item.imageName">
				  </mt-swipe-item>
				</mt-swipe>
			</section>
	   		<section>
				<div class="sucmsg">
					<div class="tit">
						<em class="icon"></em>报名成功
					</div>
	   	  	 		<p class="hint">请保持手机畅通，稍后会有团车工作人员与您联系</p>
					<div class="imgwrap">
							<img v-if="periods.qrcodeImg!=''" :src="commmonWebConfig.picHost+periods.picUrl+periods.qrcodeImg"/>
							<p v-if="periods.weixinNickname!=''">活动顾问：{{periods.weixinNickname}}</p>
						
					</div>
					<div class="publicnumber">
						公众号:
						<textarea id="copyTwo">团车</textarea>
						<button class="copyAddress" @click="copyLink">点击复制</button>
					</div>
	         		<p class="addred" style="padding-bottom:0.266666rem;">关注团车，查看门票、拼团、砍价等信息
						<!--<span v-if="periods.weixin != ''">
							{{periods.weixin}}
						</span>
	                    <span v-else>“团车”公众号</span>领票-->
	                </p>
					<!--<div class="telphone">
						<div class="redsize"><em></em>官方服务热线：<a class="size-black" href="tel:4001-501-501">4001-501-501</a></div>
						<div class="timer">服务时间：9:00-18:00</div>
	                </div>-->
				</div>
			</section>
			<!--<section>
				<div class="whyselect clearfix">
	                <div class="line1"></div>为什么选择团车<div class="line2"></div>
					<div class="pldge-wrap clearfix">
						<div class="promise1 promise  bigline btnline">
							<em class="icon01"></em>
	                      	<div class="rightbox">
								<div class="title">积淀深厚</div>
	                          	<div class="center">2010年成立,2017年</div>
	                          	<div class="size-btn">为用户至少节省20亿</div>
	                      	</div>
	                  	</div>
	                    <div class="promise2 promise btnline">
							<em class="icon02"></em>
							<div class="rightbox">
								<div class="title">覆盖全面</div>
								<div class="center">百城覆盖,超过百家汽车品牌</div>
								<div class="size-btn">曾参展团车节</div>
							</div>
						</div>
	                    <div class="promise3 promise bigline">
							<em class="icon03"></em>
							<div class="rightbox">
	                           	<div class="title">车源优质</div>
	                           	<div class="center">全国8000家4S店与主机厂的长期合作</div>
	                           	<div class="size-btn">确保正品</div>
							</div>
	                    </div>
	                    <div class="promise4 promise">
							<em class="icon04"></em>
							<div class="rightbox">
	                           	<div class="title">价格优惠</div>
	                           	<div class="center">百余城范围询价</div>
	                           	<div class="size-btn">确保优惠。</div>
							</div>
	                    </div>
					</div>
				</div>
			</section>-->
			<section>
				<div class="contentwrap">
					<div class="topStep">
						<em class="graylin01"></em>
						关注步骤
						<em class="graylin02"></em>
					</div>
					<div class="bigicon">
						<img :src='commmonWebConfig.static+"/img/carfestival/pubicon.png"' alt="" />
					</div>
					<div class="tipbtnsize">您还可以长按保存图片，扫码关注“团车”</div>
					<div class="codeimg">
						<img :src='commmonWebConfig.static+"/img/carfestival/pubcode.png"' alt="" />
					</div>
			  </div>
			</section>
	    </div>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.mint-swipe{
		height:5.33333rem;
	}

	
</style>
<script>
import msg from "@/data/dataSuc.js";
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:false,
			applyId:14195215,
			periods:{
				successBannerList:[],
				// 已使用真实数据
				successBannerCb:true,
				// 已使用真实数据
				qrcodeImg:"",
				// 已使用真实数据
				weixinNickname:"",
				// 已使用真实数据
				weixin:"",
				picUrl:""
			}
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/carfestival/suc.css"
		});
	},
	mounted:function(){
		var self = this;
		document.title="报名成功";
		getCommonJsIns.initJS({
			jsURL:"/js/app/carfestival/suc.js",
			callback:function(){
				self.webReady()
			}
		});
		/***统计添加**/
		!function(e, t, n, g, i) {
			    e[i] = e[i] || function() { 
			    	(e[i].q = e[i].q || []).push(arguments)
			    };
			    var n = t.createElement("script");
			    var tag = t.getElementsByTagName("script")[0];
			    n.async = 1;
			    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
			    tag.parentNode.insertBefore(n, tag);
			} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
	},
	methods:{
		webReady:function(){
			var str = (window.location.href).substr((window.location.href).indexOf("?"));
		 // 备份this
		 var self = this;
		 	this.bodyIsShow = true;
		 self.ajaxSubmit.ajax({
			url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applySupplement + str,
			type:"get",
			data:{},
			success:function(data){
				//数据保存
				 var result = data.response.result.periods;
				
				// 判断数据请求状态
				 if (data.responseHeader.status==200) {
		 	        self.periods.qrcodeImg = result.qrcodeImg;
     				self.periods.weixinNickname = result.weixinNickname;
     				self.periods.weixin = result.weixin;
     				self.periods.successBannerCb = result.successBannerCb;
				 	self.periods.successBannerList = result.successBannerList;
				 	self.periods.picUrl = result.picUrl
				 }
			},
			error:function(){}
		});
 
		},
		copyLink:function(){
				var e = document.getElementById("copyTwo");
				e.select(); // 选择对象
				e.setSelectionRange(0, e.value.length);
				self.len=e.value.length;
				if(document.execCommand("Copy", false, null)){
					webCommonUtil.ToastBox.show({
					  	msg:"复制成功",
					 	bottom:"50%"
					});
				}
//				Message({
//                message: "复制成功",
//                type: 'sucess',
//                center:true,
//                duration: 5 * 1000
//              })
//				alert(webCommonUtil)
				
			}
		
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carfestival/suc.vue